import React from 'react';
import LobbyBanStatusBadge from '../LobbyBanStatusBadge';

/**
 * Бейджи игрока в карточке десктопного лобби — те же, что в плашке игрока на
 * телефоне: Оффлайн, Создатель, Вы, Готов и метка фазы банов. Пока игрок не
 * готов, вместо «Готов» может стоять «Выбирает фракцию» в стиле метки
 * «Выбирает баны» (isChoosingShown): у соперника обычного лобби и у всех в
 * окне выбора рейтингового лобби.
 *
 * Что значит «Готов», решает LobbyPage (isReady): в окне выбора рейтингового
 * лобби — готов к старту (живой выбрал и подтвердил выбор), иначе — выбрал
 * фракцию.
 *
 * @param {Object} props
 * @param {Object} props.player
 * @param {boolean} props.isOwn
 * @param {boolean} props.isLobbyCreator
 * @param {string|null} props.banStatus - LOBBY_BAN_STATUSES или null вне фазы
 * @param {boolean} [props.isReady] - метка «Готов»; по умолчанию — выбрал фракцию
 * @param {boolean} [props.isChoosingShown] - показывать «Выбирает фракцию», пока не готов
 */
const LobbyDesktopPlayerBadges = ({
  player, isOwn, isLobbyCreator, banStatus, isReady = Boolean(player.factionId), isChoosingShown = false,
}) => (
  <div className="lobby-desktop-badges">
    {player.status === 'offline' && <span className="lobby-status-badge">Оффлайн</span>}
    {isLobbyCreator && <span className="lobby-creator-badge">Создатель</span>}
    {isOwn && <span className="lobby-you-badge">Вы</span>}
    {isReady && <span className="lobby-ready-badge">Готов</span>}
    {isChoosingShown && !isReady && <span className="lobby-choosing-badge">Выбирает фракцию</span>}
    <LobbyBanStatusBadge status={banStatus}/>
  </div>
);

export default LobbyDesktopPlayerBadges;
